// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"131":"stock","571":"settings"}[chunkId] + "." + {"131":"b5192544","571":"8744584b"}[chunkId] + ".js";
};